const CONCIERGE_REQUEST_CONTEXT_EVENT = 'concierge:request-context';

export type ConciergeContextData = Record<string, unknown>;

export interface ConciergeContextRequestEvent extends CustomEvent {
    detail: {
        respond: (context: ConciergeContextData) => void;
    };
}

/**
 * Request context from any active viewer/component.
 * Dispatches an event with a callback that listeners can call to provide context.
 *
 * @returns Promise resolving to context data or null if no response
 */
export function requestConciergeContext(): Promise<ConciergeContextData | null> {
    return new Promise((resolve) => {
        let responded = false;

        let timeoutId = setTimeout(() => {
            if (!responded) resolve(null);
        }, 5000);

        const respond = (context: ConciergeContextData) => {
            if (responded) return;
            responded = true;
            try {
                if (timeoutId) clearTimeout(timeoutId);
            } catch (e) {
                console.error(e);
            }
            resolve(context);
        };

        window.dispatchEvent(
            new CustomEvent(CONCIERGE_REQUEST_CONTEXT_EVENT, {
                detail: { respond },
            }),
        );
    });
}

export { CONCIERGE_REQUEST_CONTEXT_EVENT };
